export const albumsData = [
  {
    "id": "buse-harry",
    "title": "Harry, retour dans les airs",
    "description": "Reprise du vol pour Harry, jeune buse de harris",
    "category": "Animaux",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288728/_MG_0327_mdyodo.jpg",
    "eventDate": "2024-09-08",
    "displayOrder": 1,
    "photos": [
       {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288728/_MG_0327_mdyodo.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
       {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288730/_MG_0468_xdney4.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288727/_MG_0081_cfhghx.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288727/_MG_0126_evtdcd.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288728/_MG_0407_ybfffr.jpg",
        "title": "",
        "description": "",
        "order": 3
      }
     
     
    ],
    "createdAt": "2026-10-23T15:27:05.858Z",
    "updatedAt": "2026-10-23T15:27:05.859Z"
  },
  {
    "id": "champion-etoile",
    "title": "Champion et Etoile, stars du pré",
    "description": "Champion et Etoiles, un cheval et un poney à la retraite apres un belle carrière",
    "category": "Animaux",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763633/_MG_1836_ljarfs.jpg",
    "eventDate": "2024-09-17",
    "displayOrder": 1,
    "photos": [
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763633/_MG_1836_ljarfs.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763631/_MG_1927_mbvuxn.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763632/_MG_1873_v3mvaa.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763632/_MG_1889_m9sxd3.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763635/_MG_1821_emfzq3.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763636/_MG_1931_dqaqov.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763636/_MG_1814_fvngn3.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763637/_MG_1901_h3vd3g.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763640/_MG_1841_nvyd4n.jpg",
        "title": "",
        "description": "",
        "order": 9
      },
      {
        "id": "10",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792763641/_MG_1806_uitbbk.jpg",
        "title": "",
        "description": "",
        "order": 10
      }
    ],
    "createdAt": "2026-10-23T15:21:04.096Z",
    "updatedAt": "2026-10-23T15:21:04.097Z"
  },
  {
    "id": "Morgane",
    "title": "Studio avec Morgane",
    "description": "",
    "category": "portrait",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792764684/IMG_9951red-_iwndbw.jpg",
    "eventDate": "2023-02-04",
    "displayOrder": 1,
    "photos": [
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1792764684/IMG_9951red-_iwndbw.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
       {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983264/IMG_9966-5_puhdv5.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756480391/IMG_9966-4_kfalsz.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
     
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983716/IMG_9947-4_vmyjn9.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983720/IMG_7293-2_v8r0n2.jpg",
        "title": "",
        "description": "",
        "order": 5
      }
    ],
    "createdAt": "2026-10-23T15:05:07.819Z",
    "updatedAt": "2026-10-23T15:05:07.825Z"
  },
  {
    "id": "Kayne-FMF",
    "title": "Kayne au Fertois Metal Fest",
    "description": "Retour sur le concert de kayne au Fertois Metal Fest",
    "category": "concerts",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094227/_MG_5735_r23zmh.jpg",
    "eventDate": "2025-08-30",
    "displayOrder": 1,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094227/_MG_5735_r23zmh.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094228/_MG_5680_on7jz7.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094234/_MG_5709_yjvdnu.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094251/_MG_5827_jauiwz.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094262/_MG_5690_gvxjc1.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094278/_MG_5660_jlipgy.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094287/_MG_5765_qnm1p7.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094295/_MG_5773_kssozk.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094302/_MG_5737_qhjzba.jpg",
        "title": "",
        "description": "",
        "order": 9
      },
      {
        "id": "10",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094304/_MG_5743_ytf2jm.jpg",
        "title": "",
        "description": "",
        "order": 10
      },
      {
        "id": "11",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094305/_MG_5763_gh3sba.jpg",
        "title": "",
        "description": "",
        "order": 11
      },
      {
        "id": "12",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094318/_MG_5712_zjeox0.jpg",
        "title": "",
        "description": "",
        "order": 12
      },
      {
        "id": "13",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094342/_MG_5726_ju7zxx.jpg",
        "title": "",
        "description": "",
        "order": 13
      }
    ],
    "createdAt": "2026-10-22T16:10:49.600Z",
    "updatedAt": "2026-10-22T16:10:49.603Z"
  },
    
  {
    "id": "Cie-Remue-menage-2026",
    "title": "Spectacle 'Légendaire' par la compagnie Remue Ménage",
    "description": "Spectacle son et lumière 'Légendaire' par la compagnie Remue Ménage Lors de l'Eté des Arts de Chantilly",
    "category": "spectacle",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093256/_MG_8873_zaz6by.jpg",
    "eventDate": "2026-08-22",
    "displayOrder": 1,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093256/_MG_0150_jrwh8p.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093256/_MG_8873_zaz6by.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093256/_MG_0096_s3rnzs.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093256/_MG_8946_vhv12a.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093256/_MG_8965_a8mmql.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
     
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093256/_MG_9151-2_wuqwxf.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093257/_MG_8894_ol3lbc.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093257/_MG_9224_masoaa.jpg",
        "title": "",
        "description": "",
        "order": 9
      },
      {
        "id": "10",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093257/_MG_9231_jeh91d.jpg",
        "title": "",
        "description": "",
        "order": 10
      },
      {
        "id": "11",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093257/_MG_8728_kkxhbx.jpg",
        "title": "",
        "description": "",
        "order": 11
      },
      {
        "id": "12",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093258/_MG_8694_snurei.jpg",
        "title": "",
        "description": "",
        "order": 12
      },
      {
        "id": "13",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093258/_MG_9229_ss33kn.jpg",
        "title": "",
        "description": "",
        "order": 13
      },
      {
        "id": "14",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093258/_MG_9249_y6pa4v.jpg",
        "title": "",
        "description": "",
        "order": 14
      },
      {
        "id": "15",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093258/_MG_9137_kht0nu.jpg",
        "title": "",
        "description": "",
        "order": 15
      },
      {
        "id": "16",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093258/_MG_8892_fhdklp.jpg",
        "title": "",
        "description": "",
        "order": 16
      },
      {
        "id": "17",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093258/_MG_8770_rstxvg.jpg",
        "title": "",
        "description": "",
        "order": 17
      },
      {
        "id": "18",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093259/_MG_8669_l5kuim.jpg",
        "title": "",
        "description": "",
        "order": 18
      },
      {
        "id": "19",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093259/_MG_8680_pvykav.jpg",
        "title": "",
        "description": "",
        "order": 19
      },
      {
        "id": "20",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093259/_MG_9092_poom6q.jpg",
        "title": "",
        "description": "",
        "order": 20
      },
      {
        "id": "21",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093259/_MG_9863_ce8v0f.jpg",
        "title": "",
        "description": "",
        "order": 21
      },
      {
        "id": "22",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093260/_MG_9162_lgovxg.jpg",
        "title": "",
        "description": "",
        "order": 22
      },
      {
        "id": "23",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093260/_MG_0175_oipvty.jpg",
        "title": "",
        "description": "",
        "order": 23
      },
      {
        "id": "24",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093260/_MG_8971_vahjub.jpg",
        "title": "",
        "description": "",
        "order": 24
      },
      {
        "id": "25",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093260/_MG_8686_i2etmm.jpg",
        "title": "",
        "description": "",
        "order": 25
      },
      {
        "id": "26",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093260/_MG_8998_zabpzq.jpg",
        "title": "",
        "description": "",
        "order": 26
      }
    ],
    "createdAt": "2026-10-22T14:17:08.676Z",
    "updatedAt": "2026-10-22T14:17:08.679Z"
  },
    {
    "id": "BMS-Release-peniche-antipode",
    "title": "Beneath My Sins à la Péniche Antipode",
    "description": "Release Party de Beneath My Sins le 01/02/2026 à la Péniche Antipode",
    "category": "concerts",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093810/_MG_3310_sn9kot.jpg",
    "eventDate": "2026-02-01",
    "displayOrder": 1,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093810/_MG_3310_sn9kot.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093813/_MG_2777_zzqwyx.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093817/_MG_2783_fccsgr.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093818/_MG_3054_umdbop.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093821/_MG_3384_j4204e.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093822/_MG_3053_iqghpi.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093823/_MG_3315_c81jhb.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093861/_MG_3375_aiqmhx.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093862/_MG_3339_a5dhas.jpg",
        "title": "",
        "description": "",
        "order": 9
      },
      {
        "id": "10",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093863/_MG_3326_bztx3s.jpg",
        "title": "",
        "description": "",
        "order": 10
      },
      {
        "id": "11",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093864/_MG_3066_fpwpdg.jpg",
        "title": "",
        "description": "",
        "order": 11
      },
      {
        "id": "12",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093865/_MG_2910_pdfcsr.jpg",
        "title": "",
        "description": "",
        "order": 12
      },
      {
        "id": "13",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093867/_MG_2676_sdgpni.jpg",
        "title": "",
        "description": "",
        "order": 13
      },
      {
        "id": "14",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093868/_MG_2625_cks9ez.jpg",
        "title": "",
        "description": "",
        "order": 14
      },
      {
        "id": "15",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093872/_MG_2991_ju2mzi.jpg",
        "title": "",
        "description": "",
        "order": 15
      },
      {
        "id": "16",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093874/_MG_2953_kdo1qk.jpg",
        "title": "",
        "description": "",
        "order": 16
      },
      {
        "id": "17",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093878/_MG_3014_n4f0tx.jpg",
        "title": "",
        "description": "",
        "order": 17
      },
      
      {
        "id": "19",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093883/_MG_3353_jdzxra.jpg",
        "title": "",
        "description": "",
        "order": 19
      },
      {
        "id": "20",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093885/_MG_2939_txna1r.jpg",
        "title": "",
        "description": "",
        "order": 20
      },
      {
        "id": "21",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093888/_MG_3480_zwyr7j.jpg",
        "title": "",
        "description": "",
        "order": 21
      },
      {
        "id": "22",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093889/_MG_3240_ifyig5.jpg",
        "title": "",
        "description": "",
        "order": 22
      },
      {
        "id": "23",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093902/_MG_2823_vxw7yj.jpg",
        "title": "",
        "description": "",
        "order": 23
      },
      {
        "id": "24",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093903/_MG_3018_r7nn8n.jpg",
        "title": "",
        "description": "",
        "order": 24
      },
      {
        "id": "25",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093904/_MG_3471_zqitjo.jpg",
        "title": "",
        "description": "",
        "order": 25
      },
      {
        "id": "26",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093909/_MG_3058_hv7ohz.jpg",
        "title": "",
        "description": "",
        "order": 26
      },
      {
        "id": "27",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093911/_MG_3125_tuhwt2.jpg",
        "title": "",
        "description": "",
        "order": 27
      },
      {
        "id": "28",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093913/_MG_2822_qdjj6t.jpg",
        "title": "",
        "description": "",
        "order": 28
      },
      {
        "id": "29",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093915/_MG_3093_hvdhux.jpg",
        "title": "",
        "description": "",
        "order": 29
      },
      {
        "id": "30",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093918/_MG_2840_wdykw7.jpg",
        "title": "",
        "description": "",
        "order": 30
      }
    ],
    "createdAt": "2026-10-22T13:55:09.091Z",
    "updatedAt": "2026-10-22T14:08:29.574Z"
  },
  {
    "id": "Knock-Me-Out",
    "title": "Knock Me Out au Fertois Metal Fest 2025",
    "description": "Retour sur le concert de Knock Me Out au tremplin de Fertois Metal Fest 2025",
    "category": "concerts",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094222/_MG_6530_he4tzg.jpg",
    "eventDate": "2025-08-30",
    "displayOrder": 1,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094222/_MG_6530_he4tzg.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094223/_MG_6337_nbfn9n.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094240/_MG_6555_qwlq2u.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094243/_MG_6411_empymn.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094256/_MG_6353_dqklyz.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094270/_MG_6334_gyt6hx.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094298/_MG_6455_emdfgb.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094299/_MG_6393_lg3a0u.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094310/_MG_6553_ctbdbq.jpg",
        "title": "",
        "description": "",
        "order": 9
      },
      {
        "id": "10",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094338/_MG_6345_qfiphk.jpg",
        "title": "",
        "description": "",
        "order": 10
      },
      {
        "id": "11",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094344/_MG_6481_gfzum3.jpg",
        "title": "",
        "description": "",
        "order": 11
      },
      {
        "id": "12",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094353/_MG_6474_ojkrtc.jpg",
        "title": "",
        "description": "",
        "order": 12
      },
      {
        "id": "13",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094354/_MG_6480_u3hpuz.jpg",
        "title": "",
        "description": "",
        "order": 13
      },
      {
        "id": "14",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094355/_MG_6449_z9pbys.jpg",
        "title": "",
        "description": "",
        "order": 14
      },
      {
        "id": "15",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094361/_MG_6675_s6pvv0.jpg",
        "title": "",
        "description": "",
        "order": 15
      },
      {
        "id": "16",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094366/_MG_6338_ci61j1.jpg",
        "title": "",
        "description": "",
        "order": 16
      },
      {
        "id": "17",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790094376/_MG_6589_cbzvdp.jpg",
        "title": "",
        "description": "",
        "order": 17
      }
    ],
    "createdAt": "2026-10-22T13:14:17.393Z",
    "updatedAt": "2026-10-22T13:14:17.396Z"
  },
  {
    "id": "Eclipse-2026",
    "title": "Eclipse 2026",
    "description": "Mes clichés de l'éclipse d'aout 2026",
    "category": "Astrophotographie",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093288/_MG_8533_m8pvqb.jpg",
    "eventDate": "2026-08-12",
    "displayOrder": 1,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093288/_MG_8565_bawobk.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093288/_MG_8533_m8pvqb.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093299/Sans-titre-1_fxmlkn.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093299/master-low_hranhh.jpg",
        "title": "",
        "description": "",
        "order": 4
      }
    ],
    "createdAt": "2026-10-22T13:06:57.524Z",
    "updatedAt": "2026-10-22T13:06:57.525Z"
  },
    {
    "id": "baby-berzerk",
    "title": "Baby Berzerk",
    "description": "Concert de Baby Berzerk à la grange à musique",
    "category": "concerts",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093473/_MG_6094_sbaatn.jpg",
    "eventDate": "2026-05-21",
        "displayOrder": 1,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093473/_MG_6094_sbaatn.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093470/_MG_6690_ve3i7l.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093470/_MG_6644_zgeaw2.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093471/_MG_6728_nekhyk.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093474/_MG_6751_l7tc8q.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093477/_MG_6801_ip6iws.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093477/_MG_6206_pvkgzf.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093478/_MG_6318-2_dgkzwo.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093479/_MG_6670_brgmil.jpg",
        "title": "",
        "description": "",
        "order": 9
      },
      {
        "id": "10",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093479/_MG_6634_uwbxqk.jpg",
        "title": "",
        "description": "",
        "order": 10
      },
      {
        "id": "11",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093480/_MG_6592_x2f7td.jpg",
        "title": "",
        "description": "",
        "order": 11
      },
      {
        "id": "12",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093480/_MG_6611_eu2f2u.jpg",
        "title": "",
        "description": "",
        "order": 12
      },
     
      {
        "id": "15",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093482/_MG_6748_u1cwcz.jpg",
        "title": "",
        "description": "",
        "order": 15
      },
      {
        "id": "16",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093483/_MG_5981_aidwdj.jpg",
        "title": "",
        "description": "",
        "order": 16
      },
      {
        "id": "17",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093484/_MG_6318_e1m52z.jpg",
        "title": "",
        "description": "",
        "order": 17
      },
      {
        "id": "18",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093485/_MG_6697_w7lida.jpg",
        "title": "",
        "description": "",
        "order": 18
      },
      {
        "id": "19",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093485/_MG_6626_hiclm2.jpg",
        "title": "",
        "description": "",
        "order": 19
      },
      {
        "id": "20",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1790093485/_MG_5981-2_bgxh4t.jpg",
        "title": "",
        "description": "",
        "order": 20
      }
    ],
    "createdAt": "2026-09-23T13:28:58.053Z",
    "updatedAt": "2026-09-23T13:36:20.080Z"
  },
  {
    "id": "portraits-claire-cerceaux",
    "title": "Claire, ballet du cercle et de l'eau",
    "description": "La danse du corps et du cercle, suspendue entre eau et lumière.",
    "category": "portrait",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756200568/_MG_5517_1_nc7iy7.jpg",
    "eventDate": "2025-08-07",
        "displayOrder": 2,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756200568/_MG_5517_1_nc7iy7.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756207920/_MG_5526_1_dsoiy1.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756200568/_MG_5517_1_nc7iy7.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756207919/_MG_5590_1_eentrq.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756207919/_MG_5620_cm7tm3.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756207919/_MG_5617_1_srh4uf.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756207919/_MG_5517_1_zsedrf.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756208507/_MG_5620-2_nfdchj.jpg",
        "title": "",
        "description": "",
        "order": 8
      }
    ],
    "createdAt": "2025-01-26T10:00:00.000Z",
    "updatedAt": "2025-01-26T10:00:00.000Z"
  },
  {
    "id": "portraits-carla",
    "title": "Carla, rêverie au jardin du château",
    "description": "Sous les pierres anciennes, la lumière caresse la douceur d’un instant suspendu.",
    "category": "portrait",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288469/_MG_4694_suin7j.jpg",
    "eventDate": "2025-03-21",
        "displayOrder": 3,
    "photoCount": 9,
    "photos": [
      {
        "id": 1,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288469/_MG_4694_suin7j.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": 2,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288472/_MG_4716_uxutjq.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": 3,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288472/_MG_4834_m6ihx7.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": 4,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288472/_MG_4701_cisdml.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": 5,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288468/_MG_4616_wuxp9w.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": 6,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288468/_MG_4599-2_uapyo4.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": 7,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288474/_MG_4880_xjyahh.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": 8,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288472/_MG_4803_kz1yv7.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": 9,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288474/_MG_4890-4_kkavwf.jpg",
        "title": "",
        "description": "",
        "order": 9
      }
    ],
    "createdAt": "2025-01-26T10:00:00.000Z",
    "updatedAt": "2025-01-26T10:00:00.000Z"
  },
  {
    "id": "portraits-claire-chantilly",
    "title": "Claire, Hiver au jardin",
    "description": "Une série de portraits capturant l'élégance et la personnalité unique de chaque sujet.",
    "category": "portrait",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288508/_MG_4433-2_ujg7we.jpg",
    "eventDate": "2025-03-01",
        "displayOrder": 4,
    "photoCount": 4,
    "photos": [
      {
        "id": 1,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288508/_MG_4433-2_ujg7we.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": 2,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288509/_MG_4458_enryir.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": 3,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756305415/_MG_4384-5_obwqzy.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": 4,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288508/_MG_4380_oua1iq.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": 5,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288508/_MG_4435_lrniz9.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": 6,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288509/_MG_4447-Enhanced-NR_pdhdsk.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": 7,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756305738/_MG_4476_n7h4xx.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": 8,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756305739/_MG_4478_aij41e.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": 9,
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288512/_MG_4483-2_yowxqw.jpg",
        "title": "",
        "description": "",
        "order": 9
      }
    ]
  },
  {
    "id": "concert-ankor",
    "title": "Ankor au Petit Bain",
    "description": "Concert d'Ankor au Petit Bain le 19 février 2025",
    "category": "concerts",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289062/_MG_3568_zpml2f.jpg",
    "eventDate": "2025-02-19",
        "displayOrder": 5,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289059/_MG_3380_zeglvq.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289032/_MG_2661_gu8rax.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289031/_MG_2599_kb3cp8.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289022/_MG_2372_nlxri4.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289048/_MG_2920_sz7srh.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289067/_MG_4150_ixf2cd.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289042/_MG_2719_npxeiu.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289062/_MG_3568_zpml2f.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289047/_MG_2743_bibsjt.jpg",
        "title": "",
        "description": "",
        "order": 9
      },
      {
        "id": "10",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289027/_MG_2507-Enhanced-NR-2_faldyq.jpg",
        "title": "",
        "description": "",
        "order": 10
      },
      {
        "id": "11",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289051/_MG_2986_mnyzld.jpg",
        "title": "",
        "description": "",
        "order": 11
      },
      {
        "id": "12",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289067/_MG_4150_ixf2cd.jpg",
        "title": "",
        "description": "",
        "order": 12
      },
      {
        "id": "13",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289060/_MG_3440_nx9tvp.jpg",
        "title": "",
        "description": "",
        "order": 13
      },
      {
        "id": "14",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289047/_MG_2769_q6vaxt.jpg",
        "title": "",
        "description": "",
        "order": 14
      },
      {
        "id": "15",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289066/_MG_3820_fjnvhm.jpg",
        "title": "",
        "description": "",
        "order": 15
      },
      {
        "id": "16",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289062/_MG_3579_rhjjoh.jpg",
        "title": "",
        "description": "",
        "order": 16
      },
      {
        "id": "17",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289036/_MG_2685_e4qnak.jpg",
        "title": "",
        "description": "",
        "order": 17
      },
      {
        "id": "18",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289015/_MG_2084_y6nkjp.jpg",
        "title": "",
        "description": "",
        "order": 18
      }
    ],
    "createdAt": "2025-01-26T10:00:00.000Z",
    "updatedAt": "2025-01-26T10:00:00.000Z"
  },
  {
    "id": "etretat",
    "title": "Weekend à Etretat",
    "description": "Exploration de la beauté naturelle à travers des paysages époustouflants.",
    "category": "landscape",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756308038/_MG_0511-min_mw7dnn.jpg",
    "eventDate": "2021-05-25",
        "displayOrder": 6,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756308038/_MG_0511-min_mw7dnn.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288357/_MG_0587_aurtio.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288358/_MG_0639-2_z2q4rx.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288357/_MG_0204_qwblpl.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288357/_MG_0313_zuf3h1.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288356/_MG_0143_kksftp.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288356/_MG_0125_yluyhl.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288357/_MG_0221_bxzlou.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288356/_MG_0534_lipu1z.jpg",
        "title": "",
        "description": "",
        "order": 9
      }
    ],
    "createdAt": "2025-01-26T10:00:00.000Z",
    "updatedAt": "2025-01-26T10:00:00.000Z"
  },
  {
    "id": "jade-hoh",
    "title": "Jades Hells on Heels",
    "description": "Jades en concert au Hell on Heels le 02 février 2025",
    "category": "concerts",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288999/_MG_9606_dtvzk7.jpg",
    "eventDate": "2025-02-02",
        "displayOrder": 7,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288999/_MG_9606_dtvzk7.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289001/_MG_9635_fz13la.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289006/_MG_9848_cz6hs2.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289011/_MG_9918_kqkmk2.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289003/_MG_9735_pdf4ji.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "6",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288994/_MG_9535_ikn0cr.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      {
        "id": "7",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288998/_MG_9576_j10nk0.jpg",
        "title": "",
        "description": "",
        "order": 7
      },
      {
        "id": "8",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756289005/_MG_9795_ok3gtm.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "9",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288989/_MG_9363_dakq6a.jpg",
        "title": "",
        "description": "",
        "order": 9
      }
    ],
    "createdAt": "2025-01-26T10:00:00.000Z",
    "updatedAt": "2025-01-26T10:00:00.000Z"
  },
  {
    "id": "essais-devoirs",
    "title": "Devoir photos",
    "description": "Photo faites dans le cadre d'une formation photo",
    "category": "essais",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288586/IMG_3656_g2glww.jpg",
    "displayOrder": 8,
    "photos": [
      {
        "id": "1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288586/IMG_3656_g2glww.jpg",
        "title": "Nature Morte",
        "description": "Exercice sur le style de Paulette Tavormina",
        "order": 1
      },
      {
        "id": "2",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288569/_MG_7717_a1q5wv.jpg",
        "title": "Packshot Montre",
        "description": "Packshot publicitaire de montre",
        "order": 2
      },
      {
        "id": "3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288549/_MG_4284_b0idno.jpg",
        "title": "Mine de sucre - Monde miniature",
        "description": "Monde miniature en macro",
        "order": 3
      },
      {
        "id": "4",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288533/2-3-3_yzckat.jpg",
        "title": "Photo culinaire",
        "description": "",
        "order": 4
      },
      {
        "id": "5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1756288631/IMG_3989_fz2stq.jpg",
        "title": "Land Art",
        "description": "",
        "order": 5
      }
    ],
    "createdAt": "2025-01-26T10:00:00.000Z",
    "updatedAt": "2026-05-06T14:21:33.383Z",
    "photoCount": 5
  },
  {
    "id": "Kari no Ikari",
    "title": "kari no ikari",
    "description": "kari no ikari au Fertois",
    "category": "concerts",
    "coverImage": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983237/_MG_7024_ked6n9.jpg",
    "eventDate": "2025-08-30",
    "photos": [
      {
        "id": "photo-33c03fce-e3db-41ea-9982-9c60f16aa3d3",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983237/_MG_7024_ked6n9.jpg",
        "title": "",
        "description": "",
        "order": 1
      },
      {
        "id": "photo-6339858f-410b-42d7-b77c-62e9203734ee",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983232/_MG_7192_pvbp5b.jpg",
        "title": "",
        "description": "",
        "order": 2
      },
      {
        "id": "photo-60ffc8df-3233-4808-bd41-62a1d6c9ccb5",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983253/_MG_6863_kkhtfb.jpg",
        "title": "",
        "description": "",
        "order": 3
      },
      {
        "id": "photo-271a3551-7a27-457f-9b7c-ffbabd4f9b0c",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983255/_MG_6855_a33qkr.jpg",
        "title": "",
        "description": "",
        "order": 4
      },
      {
        "id": "photo-01215493-63d3-4c9a-a871-c691d180048a",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983239/_MG_6812_osznhg.jpg",
        "title": "",
        "description": "",
        "order": 5
      },
      {
        "id": "photo-19bd0912-eafd-479f-a173-261769e4a5e1",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983232/_MG_7192_pvbp5b.jpg",
        "title": "",
        "description": "",
        "order": 6
      },
      
      {
        "id": "photo-28b3613d-109b-46ac-82a3-d721f09a2813",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983224/_MG_7160_jn8idr.jpg",
        "title": "",
        "description": "",
        "order": 8
      },
      {
        "id": "photo-18a5f19c-1e4b-4401-bd65-24fede4b671b",
        "src": "https://res.cloudinary.com/dgcpwz1u4/image/upload/v1777983217/_MG_6878_opwrgl.jpg",
        "title": "",
        "description": "",
        "order": 9
      }
    ],
    "createdAt": "2026-05-06T14:20:48.205Z",
    "updatedAt": "2026-05-06T14:23:41.738Z",
    "photoCount": 9
  }
];

// Helper function to get album by ID
export const getAlbumById = (id) => {
  return albumsData.find(album => album.id === id);
};

// Helper function to get albums for gallery (without photos data for performance)
export const getGalleryAlbums = () => {
  const albums = albumsData.map(({ photos, ...album }) => ({
    ...album,
    photoCount: photos.length
  }));

  // Détection de conflits de displayOrder (avertissement dev uniquement)
  if (process.env.NODE_ENV === 'development') {
    const orderMap = {};
    albums.forEach(a => {
      if (!a.eventDate && a.displayOrder !== undefined) {
        if (!orderMap[a.displayOrder]) orderMap[a.displayOrder] = [];
        orderMap[a.displayOrder].push(a.id);
      }
    });
    Object.entries(orderMap).forEach(([order, ids]) => {
      if (ids.length > 1) {
        console.warn(
          `⚠️  Conflit de displayOrder (${order}) entre les albums : ${ids.join(', ')}. ` +
          `Modifie src/data/albums.js pour leur attribuer des valeurs uniques.`
        );
      }
    });
  }

  const toTime = (value) => {
    const t = new Date(value || 0).getTime();
    return Number.isNaN(t) ? 0 : t;
  };

  return albums.sort((a, b) => {
    const hasDateA = Boolean(a.eventDate);
    const hasDateB = Boolean(b.eventDate);

    // eventDate prioritaire : albums datés d'abord, du plus récent au plus ancien
    if (hasDateA && hasDateB) {
      const dateDiff = toTime(b.eventDate) - toTime(a.eventDate);
      if (dateDiff !== 0) return dateDiff;
    } else if (hasDateA !== hasDateB) {
      return hasDateA ? -1 : 1;
    }

    const orderDiff = (a.displayOrder ?? 999) - (b.displayOrder ?? 999);
    if (orderDiff !== 0) return orderDiff;
    // Tie-breaker : createdAt, le plus récent en premier
    return toTime(b.createdAt) - toTime(a.createdAt);
  });
};

// Helper function to get all unique categories
export const getAllCategories = () => {
  const categories = [...new Set(albumsData.map(album => album.category))];
  return categories.sort();
};

// Helper function to get albums by category
export const getAlbumsByCategory = (category) => {
  return albumsData.filter(album => album.category === category);
};

// Helper function to get recent albums
export const getRecentAlbums = (limit = 3) => {
  return albumsData
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .slice(0, limit);
};

// Helper function to search albums
export const searchAlbums = (query) => {
  const searchTerm = query.toLowerCase();
  return albumsData.filter(album => 
    album.title.toLowerCase().includes(searchTerm) ||
    album.description.toLowerCase().includes(searchTerm)
  );
};